import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance, setToken } from "./autentification.redusers";

export const fetchUser = createAsyncThunk(
  "auth/login",
  async (formData, thunkApi) => {
    try {
      const { data } = await instance.post("/auth/login", formData);
      setToken(data.accessToken);
      localStorage.setItem("token", data.accessToken);
      
      console.log("fetchUser response:", data); 

      return data;
    } catch (err) {
      return thunkApi.rejectWithValue(err.message);
    }
  }
);

export const registrationUser = createAsyncThunk(
  "auth/registr",
  async (formData, thunkApi) => {
    try {
      const { data } = await instance.post("/auth/signup", formData);
      setToken(data.accessToken);
      localStorage.setItem("token", data.accessToken);

      return data;
    } catch (err) {
      return thunkApi.rejectWithValue(err.message);
    }
  }
);

export const refreshThunk = createAsyncThunk(
  "auth/refresh",
  async (_, thunkApi) => {
    try {
      let token = thunkApi.getState().authStore.token;

      if (!token) {
        token = localStorage.getItem("token");
        if (!token) return thunkApi.rejectWithValue("No token found");
      }

      setToken(token); // Устанавливаем токен в axios

      const { data } = await instance.get("/auth/current");
      return data;
    } catch (err) {
      return thunkApi.rejectWithValue(err.message);
    }
  }
);

export const logOutThunk = createAsyncThunk(
  "auth/logOut",
  async (_, thunkApi) => {
    try {
      const { data } = await instance.get("/auth/logout");
      localStorage.removeItem("token"); 
      return data;
    } catch (err) {
      return thunkApi.rejectWithValue(err.message);
    }
  }
);


  
  export const updateThunk = createAsyncThunk(
    'auth/update',
    async (updateElem, thunkApi) => {
      try {
        const { data } = await instance.patch(`/contacts/${updateElem.id}`, updateElem.contact);
        
        return data;
      } catch (err) {
        return thunkApi.rejectWithValue(err.message);
      }
    }
  );
